'use strict';

(function ($) {

  var shrinkHeader = 300;
  var didScroll;
  var lastScrollTop = 0;
  var delta = 5;
  var navbarHeight = $('header').outerHeight();

  new WOW().init();

  if (location.hash == '#contact_form') {
    window.location.hash = "";
  }

  $(document).ready(function () {

    initStickyMenu();

    $('.mobile-nav .mobile-nav__item .mobile-nav__sublist .mobile-nav__has-sublist a').click(function (e) {
      $(this).parent().next().slideToggle();
      $(this).parent().toggleClass('active');
      e.preventDefault();
    });

    $('.filters-wrapper select').not('.no-style').niceSelect();

    $('.ajaxcart .cart__checkout').on('click', function (e) {
      e.preventDefault();
      console.log('hello');
    });

    // Read the cookie and if it's defined scroll to id
    var target = $(location).attr("hash");
    var offset = 200;
    if (target) {
      $('body,html').animate({
        scrollTop: $(target).offset().top - offset
      }, 700);
    }

    if (getUrlParameter('customer_posted')) {
      $('body,html').animate({
        scrollTop: $('#contact_form').offset().top - offset
      }, 700);
    }

    // if (location.hash == '#contact_form') {
    //   setTimeout(function() {
    //
    //     window.scrollTo(0, 0);
    //   }, 1);
    // }


    //Trigger le triage avec Nice-Select
    $('.nice-select.filters__sort--select .list li').click(function () {
      var $this = $(this);
      var val = $this.attr('data-value');

      $('#SortBy').val(val).bind('change', function () {
        Shopify.queryParams.sort_by = jQuery(this).val();
        location.search = jQuery.param(Shopify.queryParams);
      });
    });

    // FAQ
    $('.questions-holder .bloc .title-holder').click(function () {

      $('.questions-holder .bloc .title-holder').not($(this)).next().slideUp();
      $('.questions-holder .bloc .title-holder').not($(this)).parent().removeClass('active');

      $(this).parent().toggleClass('active');
      $(this).next().slideToggle();
      return false;
    });

    //FOCUS EFFECT
    $(".form-wrapper form input, .form-wrapper form textarea").focus(function () {
      $(this).parent().addClass('focus');
    }).blur(function () {
      if (!$(this).val()) {
        $(this).parent().removeClass('focus');
      }
    });

    $('.form-wrapper form').filter(':input[type=text], :input[type=password], textarea').each(function () {

      if ($.trim($(this).val()) != '') {
        $(this).parent().addClass('focus');
      };
    });

    //Focus effect on form builder
    $(".section-postuler").delegate("input, textarea", "focus", function () {
      $(this).parent().addClass('focus');
    });
    $(".section-postuler").delegate("input, textarea", "blur", function () {
      if (!$(this).val()) {
        $(this).parent().removeClass('focus');
      }
    });
  });

  $(window).scroll(function (event) {
    var scroll = getCurrentScroll();

    if (scroll >= shrinkHeader) {
      $('header').addClass('shrink');
    } else {
      $('header').removeClass('shrink');
    }

    didScroll = true;
  });

  $(window).resize(function () {
    initStickyMenu();
  });

  function getCurrentScroll() {
    return window.pageYOffset || document.documentElement.scrollTop;
  }

  setInterval(function () {
    if (didScroll) {
      hasScrolled();
      didScroll = false;
    }
  }, 250);

  function hasScrolled() {
    var st = $(window).scrollTop();

    // Make sure they scroll more than delta
    if (Math.abs(lastScrollTop - st) <= delta) return;

    // If they scrolled down and are past the navbar, add class .nav-up.
    // This is necessary so you never see what is "behind" the navbar.
    if (st > lastScrollTop && st > navbarHeight) {
      // Scroll Down
      $('header').removeClass('nav-down').addClass('nav-up');
    } else {
      // Scroll Up
      if (st + $(window).height() < $(document).height()) {
        $('header').removeClass('nav-up').addClass('nav-down');
      }
    }

    lastScrollTop = st;
  }

  function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split('=');

      if (sParameterName[0] === sParam) {
        return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
      }
    }
  };

  function initStickyMenu() {

    var windowHeight = $(window).height();
    var iconHeight = $('.menu-scroll-wrapper .icon-holder').outerHeight();
    var topMenuIcon = windowHeight - iconHeight;

    var sticky = new Sticky('[data-sticky]', {
      marginTop: topMenuIcon
    });
  }
})(jQuery);